module.exports = __webpack_public_path__ + "static/media/img_stp_card_mastercard.cb38652a.png";